export default __webpack_public_path__ + "static/media/mentor.7adbc577.png";